import { FC } from 'react';
import { ImagePreviewPropTypes } from './ImageModalPropTypes';

const ImagePreview: FC<ImagePreviewPropTypes> = (props) => {
   const { src = '' } = props;

   return (
      <img
         src={src}
         alt="image-preview"
         style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 1,
         }}
      />
   );
};

export default ImagePreview;
